shadow$provide[483] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, load:{enumerable:true, get:function() {
  return load;
}}});
var require$_DOT__SLASH_snippet = require("./snippet");
var require$_DOT__SLASH_program = require("./program");
var require$_DOT__SLASH_layout = require("./layout");
var require$_DOT__SLASH_assemble = require("./assemble");
var require$_DOT__SLASH_link = require("./link");
var require$_DOT__SLASH_priority = require("./priority");
const {load} = require$_DOT__SLASH_snippet.Snippet;
require.exportCopy(module, require$_DOT__SLASH_snippet);
require.exportCopy(module, require$_DOT__SLASH_program);
require.exportCopy(module, require$_DOT__SLASH_layout);
require.exportCopy(module, require$_DOT__SLASH_assemble);
require.exportCopy(module, require$_DOT__SLASH_link);
require.exportCopy(module, require$_DOT__SLASH_priority);

};